import { render, staticRenderFns } from "./SLSGT.vue?vue&type=template&id=773e8bdf&"
import script from "./SLSGT.vue?vue&type=script&lang=js&"
export * from "./SLSGT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports